export const registerEventsConfig = {
    parentSelector: '#bss-b2b-registration-form',
    events: {
        // Register field focus events
        registerFieldFocus: {
            selector: '#bss-b2b-register-form input[type="text"], #bss-b2b-register-form input[type="email"], #bss-b2b-register-form input[type="password"]',
            event: {
                event: 'register',
                component: '',
                element: 'text_field',
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => {
                    // Get the field name from the label
                    const label = element.closest('.bss-b2b-rf-field')?.querySelector('.label-field');
                    const fieldName = label ? label.getAttribute('title') || label.textContent.trim() : element.id;
                    return {
                        field: fieldName
                    };
                }
            }
        },

        // Register field input events
        registerFieldInput: {
            selector: '#bss-b2b-register-form input[type="text"], #bss-b2b-register-form input[type="email"], #bss-b2b-register-form input[type="password"]',
            event: {
                event: 'register',
                component: '',
                element: 'text_field',
                action: 'input',
                trigger: 'input',
                getDynamicData: (element) => {
                    // Get the field name from the label
                    const label = element.closest('.bss-b2b-rf-field')?.querySelector('.label-field');
                    const fieldName = label ? label.getAttribute('title') || label.textContent.trim() : element.id;
                    return {
                        field: fieldName,
                        field_value: element.value
                    };
                }
            }
        },

        // Register field error events
        registerFieldError: {
            selector: '#bss-b2b-register-form input[type="text"], #bss-b2b-register-form input[type="email"], #bss-b2b-register-form input[type="password"]',
            event: {
                event: 'register',
                component: '',
                element: 'text_field',
                action: 'error',
                trigger: 'blur',
                getDynamicData: (element) => {
                    // Get the field name from the label
                    const label = element.closest('.bss-b2b-rf-field')?.querySelector('.label-field');
                    const fieldName = label ? label.getAttribute('title') || label.textContent.trim() : element.id;
                    
                    // Get the error message from the span
                    const messageElement = element.closest('.bss-b2b-rf-field')?.querySelector('.bss-message');
                    
                    // Only proceed if the error message is visible and not empty
                    if (!messageElement || !messageElement.textContent.trim() || messageElement.style.display === 'none' || getComputedStyle(messageElement).display === 'none') {
                        return null; // Return null to prevent event from being pushed
                    }
                    
                    return {
                        field: fieldName,
                        error_message: messageElement.textContent.trim()
                    };
                }
            }
        },

        // Country/Phone dropdown select events
        dropdownSelect: {
            selector: '#country-list li, #phone-country-list li',
            event: {
                event: 'register',
                component: '',
                element: 'dropdown',
                action: 'select',
                trigger: 'click',
                getDynamicData: (element) => {
                    const isPhone = element.closest('#phone-country-list');
                    const selectedValue = element.getAttribute('value') || element.textContent.trim();
                    return {
                        field: isPhone ? 'Phone' : 'Country',
                        select_value: selectedValue
                    };
                }
            }
        },

        // Checkbox toggle events
        checkboxToggle: {
            selector: 'input[type="checkbox"]',
            event: {
                event: 'register',
                component: '',
                element: 'checkbox',
                action: 'change',
                trigger: 'change',
                getDynamicData: (element) => {
                    const isMarketing = element.id === 'accepts-marketing';
                    const field = isMarketing ? 'Subscribe to our newsletter' : 'I have read and accepted the privacy policy';
                    const action = element.checked ? 'on' : 'off';
                    return {
                        field: field,
                        action_value: action
                    };
                }
            }
        },

        // Checkbox error events
        checkboxError: {
            selector: '#privacy-policy',
            event: {
                event: 'register',
                component: '',
                element: 'checkbox',
                action: 'error',
                trigger: 'blur',
                getDynamicData: (element) => {
                    // Get the error message from the span
                    const messageElement = element.closest('.bss-b2b-rf-field')?.querySelector('.bss-message');
                    
                    // Only proceed if the error message is visible and not empty
                    if (!messageElement || !messageElement.textContent.trim() || messageElement.style.display === 'none' || getComputedStyle(messageElement).display === 'none') {
                        return null; // Return null to prevent event from being pushed
                    }
                    
                    return {
                        field: 'I have read and accepted the privacy policy',
                        error_message: messageElement.textContent.trim()
                    };
                }
            }
        },

        // Link click events
        registerLinks: {
            selector: '.bss-b2b-rf-privacy-policy a',
            event: {
                event: 'register',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        // Submit button click events
        registerButton: {
            selector: '.bss-b2b-rf-submit-button input[type="submit"]',
            event: {
                event: 'register',
                component: '',
                element: 'cta_button',
                action: 'click',
                action_value: 'Submit',
                trigger: 'click',
                getDynamicData: (element) => ({
                    action_value: element.value || 'Submit'
                })
            }
        },

        // Form submit events
        registerSubmit: {
            selector: '#bss-b2b-register-form',
            events: {
                valid: {
                    event: 'register',
                    component: '',
                    element: 'account',
                    action: 'submit',
                    trigger: 'submit',
                    getDynamicData: () => ({
                        action_value: 'valid'
                    })
                },
                invalid: {
                    event: 'register',
                    component: '',
                    element: 'account',
                    action: 'submit',
                    trigger: 'submit',
                    getDynamicData: () => ({
                        action_value: 'invalid'
                    })
                }
            }
        },

        // Phone country dropdown events
        phoneCountryDropdown: {
            selector: '.phone-country-select-wrapper span',
            events: {
                open: {
                    event: 'register',
                    component: '',
                    element: 'dropdown',
                    action: 'open',
                    trigger: 'click',
                    getDynamicData: () => ({
                        field: 'Phone'
                    })
                },
                close: {
                    event: 'register',
                    component: '',
                    element: 'dropdown',
                    action: 'close',
                    trigger: 'blur',
                    getDynamicData: () => ({
                        field: 'Phone'
                    })
                },
                select: {
                    selector: '#phone-country-list li',
                    event: {
                        event: 'register',
                        component: '',
                        element: 'dropdown',
                        action: 'select',
                        trigger: 'click',
                        getDynamicData: (element) => {
                            const countryCode = element.getAttribute('value');
                            const countryName = element.textContent.split('(')[0].trim();
                            return {
                                field: 'Phone',
                                action_value: countryName
                            };
                        }
                    }
                }
            }
        }
    }
}; 